import { CartItem } from "@hatch-digital-nl/bravilor-storybook";
import { RefurbishedOrderLineInterface } from "../../../common/interfaces/apiV2/shared/RefurbishedOrderLineInterface";

export const mapOrderLineToCartItem = (
    line: RefurbishedOrderLineInterface,
): CartItem => ({
    id: String(line.refurbished_product_id),
    name: line.product_name,
    image: line.product_image,
    price: line.discount_grade_price,
    originalPrice:
        line.product_price !== line.discount_grade_price
            ? line.product_price
            : undefined,
});
